(function () {
  function activateTab(trigger) {
    var targetSelector = trigger.getAttribute('data-bs-target') || trigger.getAttribute('href');
    if (!targetSelector || targetSelector.charAt(0) !== '#') return;

    var root =
      trigger.closest('.download-list') ||
      trigger.closest('.sp-index') ||
      trigger.closest('.mp-exhibition') ||
      document;

    var target = document.querySelector(targetSelector);
    if (!target) return;

    var paneRoot = target.parentElement;
    paneRoot.querySelectorAll(':scope > .tab-pane').forEach(function (pane) {
      var isTarget = pane === target;
      pane.classList.toggle('show', isTarget);
      pane.classList.toggle('active', isTarget);
    });

    root.querySelectorAll('[data-bs-toggle="tab"], [data-bs-toggle="pill"], [data-manual-tab-trigger]').forEach(function (btn) {
      var btnTarget = btn.getAttribute('data-bs-target') || btn.getAttribute('href');
      if (!btnTarget) return;
      var btnPane = document.querySelector(btnTarget);
      if (!btnPane || btnPane.parentElement !== paneRoot) return;
      var isMatch = btnTarget === targetSelector;
      btn.classList.toggle('active', isMatch);
      if (btn.hasAttribute('aria-selected')) {
        btn.setAttribute('aria-selected', isMatch ? 'true' : 'false');
      }
    });
  }

  function closeDropdowns(exceptMenu) {
    document.querySelectorAll('.sp-index .dropdown-menu.show, .sp-index .dropdown-menu.is-open').forEach(function (menu) {
      if (exceptMenu && menu === exceptMenu) return;
      menu.classList.remove('show', 'is-open');
      var toggle = menu.parentElement && menu.parentElement.querySelector('[data-bs-toggle="dropdown"], [data-manual-dropdown-toggle], .dropdown-toggle');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    });
  }

  document.addEventListener('click', function (event) {
    var dropdownToggle = event.target.closest('[data-bs-toggle="dropdown"]');
    if (dropdownToggle && dropdownToggle.closest('.sp-index')) {
      event.preventDefault();
      event.stopPropagation();
      var menu = dropdownToggle.parentElement.querySelector('.dropdown-menu');
      if (!menu) return;
      var willOpen = !menu.classList.contains('show');
      closeDropdowns(willOpen ? menu : null);
      menu.classList.toggle('show', willOpen);
      menu.classList.toggle('is-open', willOpen);
      dropdownToggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      return;
    }

    var trigger = event.target.closest('[data-bs-toggle="tab"], [data-bs-toggle="pill"]');
    if (trigger) {
      event.preventDefault();
      activateTab(trigger);

      var label = trigger.getAttribute('data-manual-dropdown-item') || trigger.textContent.trim();
      var dropdownRoot = trigger.closest('.dropdown');
      if (dropdownRoot) {
        var openToggle = dropdownRoot.querySelector('.dropdown-toggle');
        if (openToggle && label) openToggle.textContent = label;
        closeDropdowns();
      }
      return;
    }

    if (!event.target.closest('.dropdown')) {
      closeDropdowns();
    }
  });

  document.addEventListener('shopify:block:select', function (event) {
    var target = event.target;
    if (!target) return;
    var trigger = null;
    if (target.matches && target.matches('[data-bs-toggle="tab"], [data-bs-toggle="pill"]')) {
      trigger = target;
    } else if (target.querySelector) {
      trigger = target.querySelector('[data-bs-toggle="tab"], [data-bs-toggle="pill"]');
    }
    if (trigger) activateTab(trigger);
  });
})();
